<template>
    <div data-theme="light" class="z-0">
        <!--Tailwind doesn't bundle this color for some reason. Remove me when this is fixed-->
        <div class="bg-blue-700" />
        <Alerts>
            <NuxtPage />
        </Alerts>
        <UNotifications />
    </div>
    <NuxtLoadingIndicator :throttle="200" color="rgb(29 78 216)" />
</template>

<script setup lang="ts">
useHead({
    link: [
        { rel: 'icon', type: 'image/x-icon', href: '/img/favicon.ico' }
    ]
})
useResearchResultWatcher();
</script>

<style>
mark {
    color: transparent;
    background-color: rgb(191 219 254);
}

em {
    @apply text-blue-700;
}

.tiptap :first-child {
    margin-top: 0;
}

/* List styles */
.tiptap ul,
.tiptap ol {
    padding: 0 1rem;
    margin: 1.25rem 1rem 1.25rem 0.4rem;
}

.tiptap ul li p,
.tiptap ol li p {
    margin-top: 0.25em;
    margin-bottom: 0.25em;
}

.tiptap div.is-editor-empty:first-child::before {
    @apply text-gray-400;
    content: attr(data-placeholder);
    float: left;
    height: 0;
    pointer-events: none;
}

.tiptap a {
    @apply underline decoration-blue-500 text-blue-500;
    cursor: pointer;
}
</style>
